import React from 'react';
import styles from './styles.module.scss';

interface StatusBadgeProps {
  status: string;
  type: 'inbound' | 'outbound' | 'item';
}

interface StatusConfig {
  label: string;
  className: string;
}

const inboundStatusConfig: Record<string, StatusConfig> = {
  SHIPPED: {
    label: 'Shipped',
    className: 'shipped',
  },
  IN_WAREHOUSE: {
    label: 'In Warehouse',
    className: 'inWarehouse',
  },
  CLAIMED: {
    label: 'Claimed',
    className: 'claimed',
  },
  PARTLY_CLAIMED: {
    label: 'Partly Claimed',
    className: 'partlyClaimed',
  },
  COMPLETED: {
    label: 'Completed',
    className: 'completed',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    className: 'inProgress',
  },
};

const outboundStatusConfig: Record<string, StatusConfig> = {
  READY_TO_DELIVERY: {
    label: 'Ready to Delivery',
    className: 'readyToDelivery',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    className: 'inProgress',
  },
  PENDING_LABEL: {
    label: 'Pending Label',
    className: 'pendingLabel',
  },
  LABEL_GENERATED: {
    label: 'Label Generated',
    className: 'labelGenerated',
  },
  CLAIMED: {
    label: 'Claimed',
    className: 'claimed',
  },
  COMPLETED: {
    label: 'Completed',
    className: 'completed',
  },
};

const itemStatusConfig: Record<string, StatusConfig> = {
  NOT_CHECKED: {
    label: 'Not Checked',
    className: 'notChecked',
  },
  CHECKED: {
    label: 'Checked',
    className: 'checked',
  },
  IN_PROGRESS: {
    label: 'In Progress',
    className: 'itemInProgress',
  },
  READY_TO_ORDER: {
    label: 'Ready to Order',
    className: 'readyToOrder',
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type }) => {
  let config: StatusConfig | undefined;

  if (type === 'inbound') {
    config = inboundStatusConfig[status];
  } else if (type === 'outbound') {
    config = outboundStatusConfig[status];
  } else if (type === 'item') {
    config = itemStatusConfig[status];
  }

  if (!config) {
    return <span className={`${styles.statusBadge} ${styles.default}`}>{status}</span>;
  }

  return <span className={`${styles.statusBadge} ${styles[config.className]}`}>{config.label}</span>;
};
